import { ColDef } from 'ag-grid-community';
import { format } from 'erisxkit/client';
import get from 'lodash/get';
import BalanceGridRow from './types';
import NetSettledRenderer from './cellRenderers/NetSettledRenderer';
import { getTotalUSDValues } from './utils';
import MemberRenderer from './cellRenderers/MemberRenderer';
import AMLRenderer, { AML_VALUES } from './cellRenderers/AMLRenderer';
import LockRenderer, { LOCKED_STATE_VAUES } from './cellRenderers/LockRenderer';
import {
  BOOLEAN_SET_FILTER_PARAMS,
  capitalizeValueFormatter,
} from 'utils/agGrid/common/colDefOptions';
import MPRenderer from './cellRenderers/MPRenderer';
import { REMOVE_LEDGER_COL_ID } from './LedgerAccounts/useColumnDefs';

export const TOTAL_USD_VALUE_COL_ID = 'totalUsdValueColId';
const AML_COL_FIELD = 'amlState';
const LOCKED_STATE_COL_FIELD = 'lockedState';
const MEMBER_COL_ID = 'member';
export const CLICKABLE_CELLS = [
  AML_COL_FIELD,
  LOCKED_STATE_COL_FIELD,
  MEMBER_COL_ID,
  REMOVE_LEDGER_COL_ID,
];

export const columnDefs: ColDef<BalanceGridRow>[] = [
  {
    headerName: 'Net Settled',
    cellStyle: { textAlign: 'center' },
    cellRenderer: NetSettledRenderer,
    field: 'netSettled',
    filter: 'agSetColumnFilter',
    filterParams: {
      ...BOOLEAN_SET_FILTER_PARAMS,
    },
    initialWidth: 138,
  },
  {
    headerName: 'Firm Code',
    field: 'firmCode',
    filter: 'agTextColumnFilter',
    initialWidth: 130,
  },
  {
    headerName: 'Account Code',
    field: 'accountCode',
    filter: 'agTextColumnFilter',
    initialWidth: 160,
  },
  {
    headerName: 'Sub Account Code',
    field: 'subAccountCode',
    filter: 'agTextColumnFilter',
    initialWidth: 180,
  },
  {
    headerName: 'Tungsten Account ID',
    field: 'gcAccountId',
    filter: 'agTextColumnFilter',
    initialWidth: 200,
  },
  {
    headerName: 'M/P',
    colId: 'masterOrParent',
    initialWidth: 100,
    sortable: false,
    cellRenderer: MPRenderer,
  },
  {
    headerName: 'Account Name',
    field: 'name',
    filter: 'agTextColumnFilter',
    initialWidth: 200,
  },
  {
    headerName: 'State',
    field: 'locationState',
    initialWidth: 105,
  },
  {
    headerName: 'Member',
    colId: MEMBER_COL_ID,
    sortable: false,
    cellRenderer: MemberRenderer,
    initialWidth: 170,
  },
  {
    headerName: 'E-Market Account',
    field: 'emarketAccountNumber',
    filter: 'agTextColumnFilter',
    initialWidth: 178,
  },
  {
    headerName: 'AML',
    field: AML_COL_FIELD,
    cellRenderer: AMLRenderer,
    filter: 'agSetColumnFilter',
    initialWidth: 100,
    filterParams: {
      values: AML_VALUES,
      valueFormatter: capitalizeValueFormatter,
    },
  },
  {
    headerName: 'Lock',
    field: LOCKED_STATE_COL_FIELD,
    cellRenderer: LockRenderer,
    filter: 'agSetColumnFilter',
    initialWidth: 100,
    filterParams: {
      values: LOCKED_STATE_VAUES,
      valueFormatter: capitalizeValueFormatter,
    },
  },
];

export default columnDefs;
